import { Button, ListItem, ListItemText, TextField } from '@material-ui/core'
import AdvanceFilterCardExpansion from 'components/CardExpansion/AdvanceFilterCardExpansion'
import React, { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'

export const AdvanceFilterHistoryDepreciation = (props: any) => {
  const { CompanyID, fetchData, setOriginalListing } = props

  const { control, watch, setValue, getValues, register } = useForm()

  const [filterHeader, setFilterHeader] = useState('Advance Search')

  const updateFilterHeader = () => {
    const values = getValues()

    const summary = [
      values.AssetCardNo ? `Asset Card No: ${values.AssetCardNo}` : '',
      values.AssetName ? `Asset Name: ${values.AssetName}` : '',
      values.AssetCategory ? `Category: ${values.AssetCategory}` : '',
      values.Department ? `Dept: ${values.Department}` : '',
      values.Year ? `Year: ${values.Year}` : '',
      values.Period ? `Period: ${values.Period}` : '',
      values.PeriodFrom && values.PeriodTo
        ? `Period Range: ${values.PeriodFrom}-${values.PeriodTo}`
        : '',
    ].filter(Boolean)

    setFilterHeader(summary.length > 0 ? summary.join(', ') : 'Advance Search')
  }

  const onSubmitFilter = () => {
    updateFilterHeader()

    setOriginalListing([])

    const values = getValues()

    const cleanValue = (val: any) => {
      if (val === '' || val === null || val === undefined) {
        return undefined
      }
      return val
    }

    const parseNumeric = (val: any) => {
      if (val === '' || val === null || val === undefined) {
        return undefined
      }
      const parsed = Number(val)
      return isNaN(parsed) ? undefined : parsed
    }

    fetchData({
      variables: {
        CompanyID,
        skip: 0,
        take: 30,
        AssetCardNo: cleanValue(values.AssetCardNo),
        AssetName: cleanValue(values.AssetName),
        AssetCategory: cleanValue(values.AssetCategory),
        AssetSubcategory: cleanValue(values.AssetSubcategory),
        Department: cleanValue(values.Department),
        Year: parseNumeric(values.Year),
        Period: parseNumeric(values.Period),
        PeriodFrom: parseNumeric(values.PeriodFrom),
        PeriodTo: parseNumeric(values.PeriodTo),
      },
    })
  }

  const resetFilter = () => {
    setOriginalListing([])
    setFilterHeader('Advance Search')

    const fields = [
      'AssetCardNo',
      'AssetName',
      'AssetCategory',
      'Department',
      'Year',
      'Period',
      'PeriodFrom',
      'PeriodTo',
    ]

    fields.forEach(f => setValue(f, ''))

    fetchData({
      variables: { CompanyID, skip: 0, take: 30 },
    })
  }

  return (
    <AdvanceFilterCardExpansion
      customColor
      customColorCode="#faf2e8"
      summary={
        <ListItem style={{ backgroundColor: '#faf2e8', color: '#ff9800' }}>
          <ListItemText
            primary={<span className="xsTitle flex-space">{filterHeader}</span>}
          />
        </ListItem>
      }
    >
      <div style={{ fontSize: '14px', marginBottom: '15px', display: 'block' }}>
        <Controller
          as={TextField}
          name="AssetCardNo"
          control={control}
          fullWidth
          label="Asset Card No"
          variant="outlined"
          margin="dense"
          defaultValue=""
          ref={register}
        />

        <Controller
          as={TextField}
          name="AssetName"
          control={control}
          fullWidth
          label="Asset Name"
          variant="outlined"
          margin="dense"
          defaultValue=""
          ref={register}
        />
        <Controller
          as={TextField}
          name="Year"
          control={control}
          fullWidth
          label="Depreciation Year"
          variant="outlined"
          margin="normal"
          type="number"
          defaultValue=""
          ref={register}
          inputProps={{
            min: 1900,
            max: 2100,
            step: 1,
            placeholder: 'e.g. 2025',
          }}
          helperText="Enter year (e.g., 2025)"
        />

        <div style={{ display: 'flex', gap: '10px' }}>
          <Controller
            as={TextField}
            name="PeriodFrom"
            control={control}
            label="Period From"
            variant="outlined"
            margin="dense"
            fullWidth
            type="number"
            defaultValue=""
            ref={register}
            inputProps={{
              min: 1,
              max: 12,
              step: 1,
              placeholder: '1-12',
            }}
            helperText="Month (1-12)"
          />

          <Controller
            as={TextField}
            name="PeriodTo"
            control={control}
            label="Period To"
            variant="outlined"
            margin="dense"
            fullWidth
            type="number"
            defaultValue=""
            ref={register}
            inputProps={{
              min: 1,
              max: 12,
              step: 1,
              placeholder: '1-12',
            }}
            helperText="Month (1-12)"
          />
        </div>

        <Button
          type="reset"
          onClick={resetFilter}
          color="secondary"
          variant="contained"
          style={{ float: 'left', marginTop: '15px' }}
        >
          Reset
        </Button>

        <Button
          type="submit"
          onClick={onSubmitFilter}
          color="primary"
          variant="contained"
          style={{ float: 'right', marginTop: '15px' }}
        >
          Filter
        </Button>
      </div>
    </AdvanceFilterCardExpansion>
  )
}
